import { ContractContentTypeEnum, EquityContractType } from '@/api/rights/types';
import { BaseAgreement } from '@hb/coffee-widgets-agreement';
import { processSellFlowDetailsList } from '@/widgets/right-contract/utils';

// 明确 contractList 的类型
export const showOutSideContractList = async (equityContract: EquityContractType):
Promise<boolean> => {
  const contractListData = equityContract.contractList?.map((item) => {
    if (item.contentType === ContractContentTypeEnum.PDF) {
      return processSellFlowDetailsList(item);
    }
    return {
      name: item.name,
      contentUrl: item.contentUrl,
    };
  });

  if (contractListData?.length) {
    await BaseAgreement.show({
      title: equityContract.name,
      contractOption: contractListData,
    });
    return Promise.resolve(true);
  }
  return Promise.resolve(false);
};
